export default __webpack_public_path__ + "static/media/tengyart-DoqtEEn8SOo-unsplash-min.3958b107.jpg";